import * as types from '../../constants/ActionTypes'
import { fetchData, fetching } from '../Buy'

const createBasicCreator = actionType => payload => ({
  type: actionType,
  payload,
})

const fetch_postCompassFileUpload = actionType => payload => {
  const _payload = payload
  _payload.uploadPath = '/compass'
  return fetch_postFileUpload(actionType)(_payload)
}

const fetch_postBonificoFileUpload = actionType => payload => {
  const _payload = payload
  _payload.uploadPath = '/bonifico'
  return fetch_postFileUpload(actionType)(_payload)
}

const fetch_postFindomesticFileUpload = actionType => payload => {
  const _payload = payload
  _payload.uploadPath = '/findomestic'
  return fetch_postFileUpload(actionType)(_payload)
}

const fetch_postBonificoDistintaFileUpload = actionType => payload => {
  const _payload = payload
  _payload.uploadPath = '/distinta-bonifico'
  _payload.uploadMetadata = {}
  _payload.uploadMetadata.nome_attributo = 'id_pagamento'
  _payload.uploadMetadata.valore_attributo = 0

  return fetch_postFileUpload(actionType)(_payload)
}

const fetch_postFileUpload = actionType => payload => (dispatch, getState) => {
  dispatch(
    fetching({
      fetching: true,
    })
  )

  dispatch({ type: actionType })

  const formData = new FormData()
  payload.dropzone.forEach(file => {
    /**
     * FIXME unescape e' deprecata
     * dicono di usare decodeURI ma non fa lo stesso lavoro
     * sugli UTF-8
     * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa#Unicode_strings
     *
     */
    formData.append(
      window
        .btoa(unescape(encodeURIComponent(file.name.replace(/\s/g, ''))))
        .replace(/=+/, '')
        .toLowerCase(),
      file
    )
  })

  if (payload.uploadMetadata) {
    Object.keys(payload.uploadMetadata).forEach(key => {
      formData.append(key, payload.uploadMetadata[key])
    })
  }

  payload.method = 'POST'
  payload.body = formData
  payload.disableJsonSerialization = true

  payload.uri = `${window.brumbrum.url_api}/documenti/t/v1/files/${payload.id_ordine}${payload.uploadPath}`

  return fetchData(actionType)(payload)(dispatch, getState)
}

export const compassFileUploadDropped = createBasicCreator(
  types.COMPASS_FILE_UPLOAD_DROPPED
)
export const bonificoFileUploadDropped = createBasicCreator(
  types.BONIFICO_FILE_UPLOAD_DROPPED
)
export const distintaFileUploadDropped = createBasicCreator(
  types.DISTINTA_FILE_UPLOAD_DROPPED
)
export const findomesticFileUploadDropped = createBasicCreator(
  types.FINDOMESTIC_FILE_UPLOAD_DROPPED
)
export const compassFileUploadRemoved = createBasicCreator(
  types.COMPASS_FILE_UPLOAD_REMOVED
)
export const bonificoFileUploadRemoved = createBasicCreator(
  types.BONIFICO_FILE_UPLOAD_REMOVED
)
export const findomesticFileUploadRemoved = createBasicCreator(
  types.FINDOMESTIC_FILE_UPLOAD_REMOVED
)
export const postCompassFileUpload = fetch_postCompassFileUpload(
  types.POST_COMPASS_FILE_UPLOAD
)
export const postBonificoFileUpload = fetch_postBonificoFileUpload(
  types.POST_BONIFICO_FILE_UPLOAD
)
export const postFindomesticFileUpload = fetch_postFindomesticFileUpload(
  types.POST_FINDOMESTIC_FILE_UPLOAD
)
export const fetchPostFileUpload = fetch_postFileUpload
export const postBonificoDistintaFileUpload =
  fetch_postBonificoDistintaFileUpload(types.POST_BONIFICO_DISTINTA_FILE_UPLOAD)
